module.exports = __webpack_public_path__ + "static/media/player_3.d57103fb.png";